import { render } from "./App.vue?vue&type=template&id=e615963c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=e615963c&lang=scss"

import exportComponent from "C:\\GDAR_py\\apiPOS\\posWebUI\\pos\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__